import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the ItemshistoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-itemshistory',
    templateUrl: 'itemshistory.html',
})
export class ItemshistoryPage {

	loginId: string;
	email: string;
	jikgeup: string;
    api_key: string;
    version: string;

    list: any = [];
	// completed_list: any = [];
	// pending_list: any = [];
    // params: any[] = [];
    // count: number = 0;
    // max_length: number = 0;
    
	coin_unit: string;	
	cash_unit: string;
	ether_unit: string;
    
    total: string;
    value: string;

	texts: any = [];
    language : string;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        // private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
		// this.wallet_address = navParams.get("wallet_address");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "apply");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.jikgeup = localStorage.getItem("jikgeup");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.cash_unit = localStorage.getItem("cash_unit");
		this.ether_unit = localStorage.getItem("ether_unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).itemshistory;
	}

    _cancel(idx) {
        let url = "lucky/base/cancel";
		let body = JSON.stringify({ 
			api: this.api_key,
			language: this.language,
			version: this.version,
            idx: idx
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.total = res.total;

				if (res.list != undefined) {   
                    this.list = res.list;
                }

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
    }

	_init() {

		let url = "lucky/base";
		let body = JSON.stringify({ 
			api: this.api_key,
			language: this.language,
			version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.total = res.total;

				if (res.list != undefined) {   
                    this.list = res.list;
                }

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}
}



// WEBPACK FOOTER //
// ./src/pages/itemshistory/itemshistory.ts